interface operationParams {
  delay?: number;
  maxTries: number;
  detectFunc: () => unknown;
}

export const operationUtils = () => {
  const tryAgain = (params: operationParams, callback: (b: boolean) => void) => {
    const { delay, maxTries, detectFunc } = params;

    let counter = 0;

    const timer: ReturnType<typeof setInterval> = setInterval(() => {
      if (detectFunc()) {
        callback(true);
        clearInterval(timer);
        return;
      }

      if (counter >= maxTries) {
        callback(false);
        clearInterval(timer);
        return;
      }

      counter++;
    }, delay);
  };

  return {
    tryAgain,
  };
};

export default operationUtils();
